import React from "react";
import { useForm } from "antd/es/form/Form";
import { Col, Form, Input, Row, Select, Button, Upload, message } from "antd";
import { reportMappings } from "../../constants/reportMappings";
import { SectionHeader } from "../../components/SectionHeader/SectionHeader";
import css from "./Report.module.css"; 
import { PaperClipOutlined } from "@ant-design/icons";

export const Mapper = ({ headers, onSubmit, fileName, partnerData }) => {
	const [mapForm] = useForm();
	const requiredRule = [{
	  required: true,
	  message: "This field is required",
	}];
	
	const headerOptions=headers.map(header=>({
		label: header,
		value: header
	}));
	
	const onFinish = ({fields}) => {
		if(!fields.upc && !fields.cat_no) {
			message.error('Please pick UPC or Catalog Number field');
			return;
		}

		if(!fields.stock && !fields.total_sales) {
			message.error('Please pick Sales or Stock Figure field');
			return;
		}
		onSubmit(fields);
	}

	const getIndexByChar = (char) => {
		if(!char)
			return -1;
		char = char.toUpperCase();
		let number = char.charCodeAt(0) - 'A'.charCodeAt(0); 
		return number;
	}

	const getInitialValues = () => {
		let initialValues = {};
		for(let mapping of reportMappings) {
			let header = null;
			if(mapping.partnerKey) {
				const char = partnerData[mapping.partnerKey];
				header = headers[getIndexByChar(char)];
			}
			initialValues[mapping.value] = header;
		}
		return initialValues;
	}
		
  return (
	
	<div className={"ibox-holder"}>
		<SectionHeader title="Header Mapping" />
		<div className={css.previewFileName}>
			<PaperClipOutlined />
			<span className={css.fileName}>{fileName}</span>
		</div>
	  <Form
			form={mapForm}
			name="fieldMapperForm"
			autoComplete="off"
			layout="vertical"
			onFinish={onFinish}
			initialValues={{fields: getInitialValues()}}
	  >
			<Form.List name="fields">
				{(fields, { add, remove }, { errors }) => (
				<>
					{reportMappings.map(field => {
						return <Row gutter={16} key={field.value} >
							<Col xs={24} md={18} lg={12} xl={8} xxl={6}>
							<Form.Item
								name={field.value}
								className={css.reportFormItem}
								label={<span className={css.label}>{field.label}</span>}
								required={field.requiredLabel}
								rules={field.required?requiredRule:[]}
							>
								<Select
								allowClear
								placeholder={field.label}
								options={headerOptions}
								/>
							</Form.Item>
							</Col>
						</Row>
					})}
				</>
				)}
			</Form.List>
		<Row gutter={16}>
			<Col xs={24} md={24} lg={12} xl={6}>
				<Row gutter={8}>
				<Col xs={12} md={8} lg={12} xl={12}>
					<Form.Item className={css.buttonsHolder}>
						<Button
							type="primary"
							size="large"
							rootClassName={css.submitButton}
							onClick={()=>mapForm.submit()}
						>
							Apply
						</Button>
					</Form.Item>
				</Col>
				</Row>
			</Col>
		</Row>
  	  </Form>
	</div>
  );
};
